import BaseClass from "./BaseClass";

const defaultOptions = {};

export default class Session extends BaseClass {

  constructor(options) {
      super(options, defaultOptions);

      this.init();
  }

  init() {}

  setSessions(sessionValueArray) {
    var locale = $('meta[name="country"]').attr('content');

    $.ajax({
      headers: {'X-App-Locale': locale,},
      url: window.origin + '/set-search-session',
      method: 'post',
      data: sessionValueArray,
      success: function() {}
    });
  }
}
